module.exports = __webpack_public_path__ + "img/proj3-ppivpro.634ce104.png";